<template>
  <section class="page-cookies prose">
    <div class="page-cookies__body container">
      <LegalPagesNavigation />

      <h1>
        {{ $t('cookiePolicy.title') }}
      </h1>

      <h2>
        {{ $t('cookiePolicy.whatIsCookies.title') }}
      </h2>
      <p>
        {{ $t('cookiePolicy.whatIsCookies.body') }}
      </p>

      <h2>
        {{ $t('cookiePolicy.whatIsCookieFunction.title') }}
      </h2>
      <p>
        {{ $t('cookiePolicy.whatIsCookieFunction.firstParagraph') }}
      </p>
      <p>
        {{ $t('cookiePolicy.whatIsCookieFunction.secondParagraph') }}
      </p>

      <i18n path="cookiePolicy.whatIsCookieFunction.thirdParagraph" tag="p">
        <template #link>
          <a :href="onlineChoicesUrl" target="_blank">Your Online Choices</a>
        </template>
      </i18n>

      <h2>
        {{ $t('cookiePolicy.whoIAm.title') }}
      </h2>
      <p>
        {{ $t('cookiePolicy.whoIAm.body') }}
      </p>

      <h2>
        {{ $t('cookiePolicy.listTitle') }}
      </h2>

      <div
        class="uc-embed"
        uc-data="all"
        uc-embedding-type="category"
        uc-styling="true"
      />

      <a class="block mb-10" href="#" @click.prevent="openCookieSecondLayer">{{
        $t('cookiePolicy.adjustPreferences')
      }}</a>

      <p class="page-cookies__version">
        {{ $t('cookiePolicy.version') }} – {{ currentDate }}
      </p>
    </div>
  </section>
</template>

<script>
import LegalPagesNavigation from 'chimera/all/page/LegalPagesNavigation'
import AbstractCookiesPage from './AbstractCookiesPage'

export default {
  name: 'CookiesPage',

  components: {
    LegalPagesNavigation,
  },

  extends: AbstractCookiesPage,

  /**
   * @returns {{onlineChoicesUrl: string}}
   */
  data() {
    return {
      onlineChoicesUrl: this.$t('cookiePolicy.whatIsCookieFunction.url'),
    }
  },
}
</script>
